import { Garment } from './types';
import { Frame } from './frame';
import { log, FACILITY as LOG_FACILITY } from './util/log';
var LOG = LOG_FACILITY.FRAME_BUILDER;
var LOG_INTERVAL_SECONDS = 5;
var FrameBuilder = (function () {
    function FrameBuilder(handler, errorHandler, statHandler) {
        var _this = this;
        if (statHandler === void 0) { statHandler = console.log; }
        this.reset = function () {
            _this.shirtFrames = [];
            _this.pantFrames = [];
            _this.alternationCount = 0;
            _this.lastGarment = Garment.None;
            _this.lastShirtTimestamp = 0;
            _this.counter = 0;
            _this.lastLog = Date.now();
            _this.lastEmitted = Date.now();
            _this.hardStop = false;
            _this.garmentAuditor = {
                shirt: 0,
                pant: 0,
            };
        };
        this.push = function (garment, obcFrame) {
            log.debug(LOG, "recv " + garment.padEnd(6) + " " + obcFrame.timestamp);
            if (_this.hardStop) {
                return;
            }
            if (obcFrame.timestamp < Date.now() - 1000 * 60 * 62 ||
                obcFrame.timestamp < _this.lastShirtTimestamp - 1000 * 2) {
                _this.hardStop = true;
                _this.errorHandler({
                    message: 'obc-timestamp-error',
                    timestamp: obcFrame.timestamp,
                });
                return;
            }
            if (_this.lastGarment === garment) {
                _this.alternationCount = 0;
            }
            else {
                ++_this.alternationCount;
            }
            _this.lastGarment = garment;
            if (garment === Garment.SHIRT) {
                _this.garmentAuditor.shirt++;
                if (_this.shirtFrames.length > 2) {
                    _this.shirtFrames.shift();
                }
                _this.shirtFrames.push(obcFrame.clone());
                _this.lastShirtTimestamp = obcFrame.timestamp;
                _this.lastShirtSys = Date.now();
                _this.lastShirt = obcFrame.timestamp;
            }
            else {
                _this.garmentAuditor.pant++;
                if (_this.pantFrames.length > 2) {
                    _this.pantFrames.shift();
                }
                _this.pantFrames.push(obcFrame.clone());
                _this.lastPantSys = Date.now();
                _this.lastPant = obcFrame.timestamp;
            }
            if (_this.shirtFrames.length && _this.pantFrames.length) {
                var shirtFrame = _this.shirtFrames.shift();
                var pantFrame = _this.pantFrames.shift();
                _this.lastRelease = shirtFrame.timestamp;
                var frame = new Frame();
                frame.build(shirtFrame, pantFrame);
                log.debug(LOG, 'emit'.padEnd(11) + " " + frame.timestamp);
                if (_this.handler) {
                    ++_this.counter;
                    _this.lastEmitted = Date.now();
                    _this.handler(frame);
                }
                if (_this.alternationCount > 1 && _this.shirtFrames.length) {
                    log.debug(LOG, 'flushing shirt queue');
                    _this.shirtFrames = [];
                }
                if (_this.alternationCount > 1 && _this.pantFrames.length) {
                    log.debug(LOG, 'flushing pant queue');
                    _this.pantFrames = [];
                }
            }
            if (Date.now() > _this.lastLog + LOG_INTERVAL_SECONDS * 1000) {
                _this.lastLog = Date.now();
                _this.statHandler({
                    emittedFps: _this.counter / LOG_INTERVAL_SECONDS,
                    auditFrameBuilderObcReads: _this.garmentAuditor,
                });
                _this.counter = 0;
            }
        };
        log.debug(LOG, 'FrameBuilder.constructor');
        this.handler = handler;
        this.errorHandler = errorHandler;
        this.statHandler = statHandler;
        this.shirtFrames = [];
        this.pantFrames = [];
        this.alternationCount = 0;
        this.lastGarment = Garment.None;
        this.lastShirtTimestamp = 0;
        this.counter = 0;
        this.lastLog = Date.now();
        this.lastEmitted = Date.now();
        this.hardStop = false;
        this.garmentAuditor = {
            shirt: 0,
            pant: 0,
        };
        this.lastRelease = 0;
        this.lastShirt = 0;
        this.lastPant = 0;
        this.lastShirtSys = 0;
        this.lastPantSys = 0;
    }
    return FrameBuilder;
}());
export default FrameBuilder;
//# sourceMappingURL=frame-builder.js.map